import { uiText, useUiLanguage } from '../../../utils/uiTranslation';
import React from 'react';

const UnavailableVisual = ({ message = 'No compatible data is available for this widget yet.' }) => { useUiLanguage(); return (<div className="analytics-visual analytics-visual-unavailable">
    <i className="fa-solid fa-circle-exclamation" />
    <span>{uiText(message)}</span>
  </div>); };

export default UnavailableVisual;
